module.exports = __webpack_public_path__ + "static/media/slide13.e0e8bb31.jpg";